import { useState } from 'react';

import { Button } from '@components/button';
import { Checkbox } from '@components/checkbox';
import { IconTrash } from '@components/icons/trash';
import { hideModal, Modal, useModal } from '@components/modal';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useDeleteWorkTypes } from 'api/worktypes/hooks';
import { WorkType } from 'api/worktypes/requests';
import { useStore } from 'models/Provider';

import locale from './locale.json';

export const useWorkTypeDeleteModal = () => useModal(WorkTypeDeleteModal, {});

const WorkTypeDeleteModal = ({ workType }: { workType: WorkType }) => {
  const { t } = useScopedTranslate(locale);
  const [isConfirm, setIsConfirm] = useState(false);
  const { current } = useStore();
  const onSuccess = async () => {
    current.loadInfo();
    hideModal();
  };
  const deleteMutation = useDeleteWorkTypes({ id: workType.id, onSuccess: () => onSuccess() });
  return (
    <Modal>
      <Modal.SimpleHeader title={t('deleteWorkType')} />
      <Modal.Content>
        <Stack space={6}>
          <Stack space={2}>
            <Text font="regular16" text={t('areYouSure')} />
            {workType.numJobs > 0 && (
              <Text font="regular16" text={t('connectedToJobs', { nrJobs: workType.numJobs })} />
            )}
            <Text font="regular16" color="red100" text={t('cannotBeUndone')} />
          </Stack>
          <Separator />
          <Stack space={4}>
            <Text font="semibold14" text={t('pleaseConfirm')} />
            <Checkbox label={t('iUnderstand')} onChange={setIsConfirm} />
          </Stack>
          <Stack orientation="horizontal" space={4} justify="flex-end">
            <Button variant="secondary" onClick={hideModal} text={t('cancel')} />
            <Button
              isDisabled={deleteMutation.isLoading || !isConfirm}
              onClick={() => deleteMutation.mutate()}
              variant="primary-red"
              iconLeft={<IconTrash />}
              text={t('delete')}
            />
          </Stack>
        </Stack>
      </Modal.Content>
    </Modal>
  );
};
